import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

import Text from "../../atoms/Text/Text";

export interface HeaderStep {
  context: "new_subscription" | "manage";
  step?: number;
  totalSteps?: number;
}

interface Props {
  headerStep: HeaderStep;
  title?: string;
  goBack?: () => void;
}

const Header = ({ headerStep, title, goBack }: Props) => {
  const { t } = useTranslation();

  return (
    <Box className="Header">
      <Box className="alignStart">
        <ArrowBackIosNewIcon
          className="Logos"
          onClick={goBack}
          sx={{ visibility: goBack ? 'visible' : 'hidden' }}
        />
      </Box>
      <Box className="alignCenter">
        {headerStep.step && headerStep.totalSteps && headerStep.step <= headerStep.totalSteps && (
          <Text
            className="steps"
            children={`${t("subscription:HEADER.STEP")} ${headerStep.step}/${headerStep.totalSteps}`}
          />
        )}
        {title && <Text className="title" children={title} />}
      </Box>
      <Box className="alignEnd" />
    </Box>
  );
};

export default Header;
